import {z} from 'zod';

import {AvailableDiscountSchema, DiscountSourceTypeSchema} from '@dms/api/shared';

export const EditMaterialItemFormSchema = z.object({
  serialNumber: z.number().nullish(),
  catalogNumber: z.string().nullish(),
  manufacturerId: z.string().nullish(),
  name: z.string().nullish(),
  warehouseId: z.string().nullish(),
  storageLocation: z.string().nullish(),
  rabatGroupId: z.string().nullish(),
  priceType: z.string().nullish(),
  neededAt: z.date().nullish(),
  workItemGroupId: z.string().nullish(),
  isOneTimeSale: z.boolean(),
  quantity: z.number(),
  sellingPricePerUnit: z.number(),
  vatType: z.string(),
  vatFreeCode: z.string().nullish(),
  mechanic: z.string().nullish(),
  isUnitPriceWithVat: z.boolean(),
  isCustomPrice: z.boolean(),
  discount: z.object({
    isDoNotApplyDiscount: z.boolean(),
    isDiscountEnable: z.boolean(),
    discountSourceType: DiscountSourceTypeSchema.nullish(),
    discountRate: z.number().nullish(),
    availableDiscounts: z.array(
      AvailableDiscountSchema.extend({discountRate: z.number().min(0).max(100).nullish()})
    ),
  }),
});

export type EditMaterialItemForm = z.infer<typeof EditMaterialItemFormSchema>;
